import BTween from 'b-tween';
export function findNode(dom, selector) {
    try {
        return dom.querySelector(selector);
    }
    catch (e) {
        console.error('[byteui/Anchor：]', e);
        return null;
    }
}
export function slide(el, top, cb) {
    var tween = new BTween({
        from: {
            scrollTop: el.scrollTop,
        },
        to: {
            scrollTop: top,
        },
        duration: 300,
        onUpdate: function (keys) {
            el.scrollTop = keys.scrollTop;
        },
        onFinish: function () {
            cb && cb();
        },
    });
    tween.start();
}
